import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="Kā spēlēt?" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Katru dienu sešos gājienos atmini jaunu piecburtu vārdu{' '}
        <span className="font-bold">pamatformā</span> – tas var būt{' '}
        <span className="font-bold">lietvārds</span>{' '}
        <span className="italic">(sugas vārds)</span> vai{' '}
        <span className="font-bold">darbības vārds</span>. Arī katram minējumam
        jābut latviešu valodas vārdam pamatformā. Pēc katra minējuma burtu fona
        krāsa mainīsies, lai parādītu, cik tuvu īstajam vārdam ir minējums.
      </p>

      <div className="mb-1 mt-4 flex justify-center">
        <Cell value="A" />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="L"
          status="correct"
        />
        <Cell value="N" isCompleted={true} />
        <Cell value="I" isCompleted={true} />
        <Cell value="S" isCompleted={true} />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Zaļā krāsa norāda, ka burts "L" atrodas pareizajā vietā.
      </p>

      <div className="mb-1 mt-4 flex justify-center">
        <Cell value="F" isCompleted={true} />
        <Cell value="L" isCompleted={true} />
        <Cell
          isRevealing={true}
          isCompleted={true}
          value="Ī"
          status="present"
        />
        <Cell value="Z" isCompleted={true} />
        <Cell value="E" isCompleted={true} />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Dzeltenā krāsa norāda, ka burts "Ī" ir vārdā, bet neatrodas īstajā
        vietā.
      </p>

      <div className="mb-1 mt-4 flex justify-center">
        <Cell value="Ī" isCompleted={true} />
        <Cell value="L" isCompleted={true} />
        <Cell value="E" isCompleted={true} />
        <Cell isRevealing={true} isCompleted={true} value="N" status="absent" />
        <Cell value="S" isCompleted={true} />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Pelēkā krāsa norāda, ka burts "N" nav vārdā.
      </p>

      <p className="mt-6 mb-1 text-base font-bold italic text-gray-500 dark:text-gray-300">
        Par spēli
      </p>
      <p className="text-sm italic text-gray-500 dark:text-gray-300">
        Šis ir populārās vārdu minēšanas spēles "Wordle" atvērtā{' '}
        <a
          href="https://github.com/cwackerfuss/react-wordle"
          target="_blank"
          rel="noreferrer"
          className="font-bold underline"
        >
          pirmkoda
        </a>{' '}
        klons, kurš pielāgots latviešu valodai. Vārdu saraksts veidots
        izmantojot{' '}
        <a
          href="https://tezaurs.lv"
          target="_blank"
          rel="noreferrer"
          className="font-bold underline"
        >
          tēzaura
        </a>{' '}
        atvērtos datus. Oriģinālo spēles versiju (angļu valodā) izmēģini{' '}
        <a
          href="https://www.nytimes.com/games/wordle/index.html"
          className="font-bold underline"
        >
          šeit
        </a>
        .
      </p>
    </BaseModal>
  )
}
